// sending postmessages to player
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();const sendPlayerPostMessage = (messageToSend: string) => {
  const player = window.frames['player'];

  if (!player) {
    return null;
  }

  const message = JSON.stringify({
    command: messageToSend,
  });

  if (player && typeof player.postMessage === `function`) {
    player.postMessage(message, '*');
  }
};

export { sendPlayerPostMessage };
